module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_9006.0d8ad067.png";